var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 6C9.30228 6 9.75 6.44772 9.75 7V12C9.75 12.5523 9.30228 13 8.75 13H3.75C3.19772 13 2.75 12.5523 2.75 12V7C2.75 6.44772 3.19772 6 3.75 6H8.75ZM3.75 12H8.75V7H3.75V12ZM6.25 7.75C6.52614 7.75 6.75 7.97386 6.75 8.25V9H7.5C7.77614 9 8 9.22386 8 9.5C8 9.77614 7.77614 10 7.5 10H6.75V10.75C6.75 11.0261 6.52614 11.25 6.25 11.25C5.97386 11.25 5.75 11.0261 5.75 10.75V10H5C4.72386 10 4.5 9.77614 4.5 9.5C4.5 9.22386 4.72386 9 5 9H5.75V8.25C5.75 7.97386 5.97386 7.75 6.25 7.75ZM12.25 2.75C12.8023 2.75 13.25 3.19772 13.25 3.75V9.25C13.25 9.80229 12.8023 10.25 12.25 10.25H11.25C10.9739 10.25 10.75 10.0261 10.75 9.75C10.75 9.47386 10.9739 9.25 11.25 9.25H12.25V3.75H7.25V4.5C7.25 4.77614 7.02614 5 6.75 5C6.47386 5 6.25 4.77614 6.25 4.5V3.75C6.25 3.19772 6.6977 2.75 7.25 2.75H12.25Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.a26319b7d6f26a0bdb59545ff142a038.svg";
export { ForwardRef as ReactComponent };